import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';

/**
 * @typedef {import ('../../interfaces/services/ILogin.interface').ILoginForm} ILoginForm
 */
const defaultValues = {
  user: '',
};

const resolver = yupResolver(
  yup.object().shape({
    user: yup.string().required('Campo obligatorio'),
  })
);

export { defaultValues, resolver };
